import type { PlatformAdmin } from "@repo/types";

interface PlatformAdminSession {
  token: string;
  admin: PlatformAdmin;
}

const STORAGE_KEY = "aq1.platformAdmin.session";
const isBrowser = typeof window !== "undefined";
let session: PlatformAdminSession | null = null;

const serialize = (value: PlatformAdminSession) => JSON.stringify(value);
const parse = (value: string | null) => {
  if (!value) return null;
  try {
    const parsed = JSON.parse(value) as PlatformAdminSession;
    if (parsed && typeof parsed.token === "string" && parsed.token.length > 0) {
      return parsed;
    }
  } catch {
    if (isBrowser) {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  }
  return null;
};

export const platformAdminSessionStorage = {
  loadSession(): PlatformAdminSession | null {
    if (session) return session;
    if (!isBrowser) return null;
    session = parse(window.localStorage.getItem(STORAGE_KEY));
    return session;
  },
  getToken(): string | null {
    return session?.token ?? null;
  },
  getAdmin(): PlatformAdmin | null {
    return session?.admin ?? null;
  },
  setSession(next: PlatformAdminSession | null, options?: { remember?: boolean }) {
    session = next;
    if (!isBrowser) return;
    if (next && options?.remember) {
      window.localStorage.setItem(STORAGE_KEY, serialize(next));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  },
  clearSession() {
    session = null;
    if (isBrowser) {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  }
};
